import React, { memo, useEffect, useMemo } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import InsightApp from "../../../InsightStory/components/InsightApp/InsightApp";

import "./HawkeyeInsightStory.scss";

function HawkeyeInsightStory(props) {
  const { selectedStory, storyList, onStorySelection, question } = props;

  const [state, dispatch] = useAxiomState(
    {
      loading: true,
      circleData: [],
      insightList: [],
      field: null,
    },
    props.appName,
    props.appID,
    "HawkeyeInsightStory",
    props.componentID
  );

  // Fetch story data on story change
  useEffect(() => {
    dispatch({
      loading: true,
      circleData: [],
      insightList: [],
      field: null,
    });
    dispatch({ selectedStory }, "AxiomEvent", "getStoryData");
  }, [dispatch, selectedStory]);

  const stories = useMemo(() => storyList.filter((s) => s.isActionable), [storyList]);

  return (
    <div className="hawkeye-insight-story">
      <InsightApp
        question={question}
        loading={state.loading}
        circleData={state.circleData}
        insightList={state.insightList}
        field={state.field}
        selectedStory={selectedStory.id}
        storyList={stories}
        changeStory={onStorySelection}
        appName={props.appName}
        appID={props.appID}
        componentID={props.componentID}
      />
    </div>
  );
}

export default memo(HawkeyeInsightStory);
